import React, { Component } from 'react';
import { IosToggle, FlipToggle, SkewToggle } from 'reacttoggles'
import { Tabs, Tab } from 'react-bootstrap'

const components = {
    IosToggle,
    FlipToggle,
    SkewToggle
}

const iframes = [
    `//codepen.io/nerdchacha/embed/ryGVzK/?theme-id=dark&default-tab=js&embed-version=2`,
    `//codepen.io/nerdchacha/embed/EWwjvd/?theme-id=dark&default-tab=js&embed-version=2`,
    `//codepen.io/nerdchacha/embed/JWrdyx/?theme-id=dark&default-tab=js&embed-version=2`,
]

class Checked extends Component {
    constructor () {
        super()
        this.state = { checked: false }
        this.handleClick = this.handleClick.bind(this)
    }
    handleClick () {
        this.setState({checked: !this.state.checked})
    }
    render() {
        return (
            <div>
                <div className="col-md-12">
                    <div className="checkbox">
                        <label>
                            <input
                                type="checkbox"
                                checked={this.state.checked}
                                onClick={this.handleClick}
                                />
                            Controlling Element
                        </label>
                    </div>
                </div>
                <Tabs defaultActiveKey={0} id="uncontrolled-tab-example" className="card" >
                    {Object.keys(components).map((key, i) => (
                        <Tab eventKey={i} key={i} title={key}>
                            {
                                React.createElement(components[key], {
                                    checked: this.state.checked
                                })
                            }
                            <iframe
                                height='265'
                                scrolling='no'
                                title='aJyPJy'
                                src={iframes[i]}
                                frameBorder='no'
                                allowTransparency='true'
                                allowFullScreen='true'
                                >
                            </iframe>
                        </Tab>
                    ))}
                </Tabs>
            </div>
        );
    }
}

export default Checked;




// WEBPACK FOOTER //
// ./src/components/Controlled.js